
import React from 'react';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Calendar, Clock } from 'lucide-react';
import { ReschedulePolicy } from '@/types/dashboard';

interface PolicyAlertProps {
  policy: ReschedulePolicy;
  hoursUntilAppointment: number;
  canReschedule: boolean;
}

const PolicyAlert: React.FC<PolicyAlertProps> = ({
  policy,
  hoursUntilAppointment,
  canReschedule
}) => {
  return (
    <>
      {!canReschedule && (
        <Alert variant="destructive">
          <Clock className="h-4 w-4" />
          <AlertTitle>Reagendamento não permitido</AlertTitle>
          <AlertDescription>
            Só é possível reagendar com pelo menos {policy.minHoursBeforeAppointment} horas de antecedência.
            Restam apenas {hoursUntilAppointment} horas para a consulta.
          </AlertDescription>
        </Alert>
      )}

      <Alert>
        <Calendar className="h-4 w-4" />
        <AlertTitle>Política de Reagendamento</AlertTitle>
        <AlertDescription>
          <p>• Máximo de {policy.maxReschedulesPerAppointment} reagendamentos por consulta</p>
          <p>• Reagendamento deve ser solicitado com pelo menos {policy.minHoursBeforeAppointment}h de antecedência</p>
        </AlertDescription>
      </Alert>
    </>
  );
};

export default PolicyAlert;
